import React, { FC } from 'react';
import { MonitorsUnitType } from '../../QueuePanel/QueuePanel';
import { TicketStatus } from '../../../../types/enums';
import classes from './ModalQueueNewTicket.module.scss';
import classNames from 'classnames';
import { QueueArrowIcon } from '../../../../assets/svgComponents/QueueArrowIcon';
import { isQueueScreenDarkTheme } from '../../../../constants/API';
import modalBase from '../../../ModalBase/ModalBase.module.scss';

type ModalQueueNewTicketProps = {
  tickets: MonitorsUnitType;
};

const ModalQueueNewTicket: FC<ModalQueueNewTicketProps> = ({ tickets }) => {
  return (
    <div
      className={classNames(modalBase.modal, modalBase.active, {
        [classes.darkThemeModalOverlay]: isQueueScreenDarkTheme
      })}
    >
      <div
        className={classNames(modalBase.container, classes.modalContainer, {
          [classes.darkModalContainer]: isQueueScreenDarkTheme
        })}>
        <div className={classNames(classes.ticketsListContainer)}>
          {tickets.items.map((e, idx) => {
            if (e.status !== TicketStatus.TakeInWorking && idx < 4) {
              return (
                <div className={classes.ticketWrapper} key={idx}>
                  <div className={classNames(classes.ticketAlign, classes.ticketName)}>
                    <span>{e.itemName}</span>
                  </div>

                  <div className={classes.arrowIconWrapper}>
                    <QueueArrowIcon />
                  </div>

                  {/* <div className={classNames(classes.ticketAlign, classes.ticketIcon)} /> */}
                  <div
                    className={classNames(classes.ticketAlign, classes.ticketWindow, {
                      [classes.darkThemeText]: isQueueScreenDarkTheme
                    })}>
                    <span>{e.window}</span>
                  </div>
                </div>
              );
            }
          })}
        </div>
      </div>
    </div>
  );
};

export default ModalQueueNewTicket;
